import { DailyOverviewConfig } from "@energylab/shared-components/constants/config/dailyOverviewConfig";

export const dailyOverviewConfig: DailyOverviewConfig = {
    disableColorOverlay: true,
    image: "https://res.cloudinary.com/energylab/image/upload/v1629467838/ing/ActivityBackground.jpg"
};
